import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const submitProspectus = (data) => axios.post(`${API}/forms/prospectus`, data);
export const submitEnquiry = (data) => axios.post(`${API}/forms/enquiry`, data);
export const submitContact = (data) => axios.post(`${API}/forms/contact`, data);
